<template>
  <div>
    <v-layout> 
    

    <v-menu 
      offset-y
      v-model="menuSpacer"
      :close-on-content-click="false"
      :nudge-width="200"
    >

      <template #activator="{ on: menuSpacer }">
        <v-tooltip bottom>
          <template #activator="{ on: tooltip }">
            <v-btn 
              icon flat small 
              class="pa-0 ma-0 text-xs-right"
              v-on="{ ...tooltip, ...menuSpacer }"
            >
              <v-icon>format_line_spacing</v-icon>
            </v-btn>
          </template>
          <span>{{ helpSpacerTooltip }}</span>
        </v-tooltip>
      </template>

      <v-card>
        <v-card-text>
          <v-form>
            <v-layout align-center justify-end row fill-height>
              <v-flex py-0>
                <span class="caption"> {{ helpSpacerTooltip }} </span>
                <v-slider 
                  class="mt-0"
                  v-model="spacingLayout_top"
                  prepend-icon="vertical_align_top"
                  max=10
                  min=0
                  v-validate="'min_value:0|max_value:10'"
                  :data-vv-name="'layout-up-' + section"
                  data-vv-as='espacement au dessus'
                  :error-messages="errors.collect('layout-up-' + section)"
                  data-vv-delay="5000"
                  v-on:blur="updateVuexLayoutModelObject({'cv_id': cv_id, 'data_sent': vuexLayoutModelObject })"
                  
                ></v-slider>

                <v-slider
                  class="mt-0"
                  v-model="spacingLayout_bottom"
                  prepend-icon="vertical_align_bottom"
                  max=10
                  min=0
                  v-validate="'min_value:0|max_value:10'"
                  :data-vv-name="'layout-bottom-' + section"
                  data-vv-as='espacement au dessous'
                  :error-messages="errors.collect('layout-bottom-' + section)"
                  data-vv-delay="5000"
                  v-on:blur="updateVuexLayoutModelObject({'cv_id': cv_id, 'data_sent': vuexLayoutModelObject })"

                ></v-slider>

              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </v-menu>


    <v-dialog
      v-model="helpDialog"
      width="500"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          icon flat small
          v-on="on"
          class="pa-0 ma-0 mr-2"
        >
          <v-icon>help_outline</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-actions> 
          <v-layout justify-end>
            <v-btn 
              icon 
              @click="helpDialog=false"
              class=""
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-card-actions>
        <v-card-text>
          <h5 class="headline text-xs-center">AIDE</h5>
          <v-layout row wrap align-start>
            <v-flex xs12>
              <v-icon class="mr-2">format_line_spacing</v-icon> 
              <p> {{ helpTextSpacer }}</p>
            </v-flex>
            <v-flex xs12>
              <v-icon class="mr-2">expand_less</v-icon><v-icon class="mr-2">expand_more</v-icon>
              <p> {{ helpTextUPdOwn }}</p>
            </v-flex>
            <v-flex xs12>
              <v-icon class="mr-2">clear</v-icon>
              <p> {{ helpTextDelete }}</p>
            </v-flex>

          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>


    </v-layout>
  </div>
    
</template>


<script>

  /*
  Component qui affiche un widget de slider afin de dimensionner les espaces entre sections.
  Prend 2 propos : le cv_id et la section.
  v-model="vuexLayoutModelObject[`spacing_${section}_top`]"  ==> astuce pour récupérer vuexLayoutModelObject.spacing_edu_top si la
  prop section est 'edu'.

  A propos du tooltip : celui-ci persistait lorsque l'on cliquait sur le bouton et qu'il disparaissait.
  Voir la réponse de John Leider : https://github.com/vuetifyjs/vuetify/issues/1919
  Il faut appliquer le v-if au tooltip et pas au bouton.

  -- VUEX --
  Le getVuexLayoutModelObject() est effectué sur la vue CvEdit.vue (si on l'avait placée ici, elle se serait exécutée N fois!)
  Deux objet v-model bindé sur des getter/setter afin d'eviter "Error with vuex: Do not mutate vuex store state outside mutation handlers".

  */

  import { mapActions, mapState } from 'vuex';
  

  export default {
    props: ['cv_id', 'section'],
    data() {
      return {
        helpDialog: false,
        helpTextSpacer: `
          Ce menu vous permet d'ajouter des espaces au dessus et/ou au dessous de cette section
          afin d'aérer votre CV. 
          Ce menu existe aussi sur les éléments de votre cv (formations, expériences pro).
          `,
        helpTextUPdOwn: `
          Ces flèches vous permettent d'ordonnancer la façon dont les éléments de votre CV seront affichés.
          Cliquez sur la flèche du haut pour déplacer l'élément vers le haut.
          Cliquez sur la flèche du bas pour déplacer l'élément vers le bas.
        `,
        helpTextDelete: `
          Supprime l'élément (une confirmation vous sera demandée avant suppression définitive).
        `,
        menuSpacer: false,
        helpSpacerTooltip: "Ajuster l'espacement avant et après cette section",
        openDialogLayout: false,
        cvid: this.cv_id
      }
    },
    computed: {
     // getter setter pour le v-model
      spacingLayout_top: {
        get() {
          return this.$store.state.sectionLayout.vuexLayoutModelObject[`spacing_${this.section}_top`];
        },
        set(value) {
          // NOTE : on envoie un objet qui est ensuite décomposé dans la mutation MODEL_OBJECT_2
          // noter le namespace 'module/MUTATION'
          this.$store.commit( 'sectionLayout/MODEL_OBJECT_2', { 'field': `spacing_${this.section}_top`, 'resp': value } ) 
        }
      },
      spacingLayout_bottom: {
        get() {
          return this.$store.state.sectionLayout.vuexLayoutModelObject[`spacing_${this.section}_bottom`];
        },
        set(value) {
          this.$store.commit( 'sectionLayout/MODEL_OBJECT_2', { 'field': `spacing_${this.section}_bottom`, 'resp': value } )
        }
      },
      ...mapState('sectionLayout', [
        'vuexLayoutModelObject',
        'getErrorLayout',
        'updateLayoutError',
        'vuexIsLoadingLayout'
      ]),
    },
    methods: {
      ...mapActions('sectionLayout', [
        'getVuexLayoutModelObject',
        'updateVuexLayoutModelObject',
      ]),
    },
  
    
  }
</script>

<style>

 p {
  text-align: justify;
  text-justify: inter-word;
}

</style>
